<footer>
	<div class="footer">
		<p class="copyright">© 2017-2018 copyrights.</p>
	</div>
</footer>
